export default __webpack_public_path__ + "static/media/Income-Builder-Brochure.703581b9.pdf";